import { Box } from '@mui/material';
import { Theme } from '@mui/material/styles';

import { makeStyles } from '@mui/styles';

import type { DetailsItem } from './interface';
import DetailsItemElement from './detailsItem';

interface StyleProps {
  numberOfColumns: number;
}

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    display: 'grid',
    gridTemplateColumns: ({ numberOfColumns }: StyleProps) => `repeat(${numberOfColumns}, auto)`,
    rowGap: theme.spacing(2)
  }
}));

interface Props extends Partial<Pick<StyleProps, 'numberOfColumns'>> {
  items: DetailsItem[];
}

const DetailsList = ({ numberOfColumns = 2, items }: Props) => {
  const classes = useStyles({ numberOfColumns });
  const DetailsItemElements = items.map((item, index) => (
    <DetailsItemElement label={item.label} value={item.value || '-'} key={index} />
  ));

  return <Box className={classes.container}>{DetailsItemElements}</Box>;
};

export default DetailsList;
